import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox, Form } from "antd";
import { useFormContentBlocker, useFormService, useI18n } from "../../contexts";
import { FormServiceLayout } from "./service";
const FormFieldTemplateSuccessorDeletionCheck = (param)=>{
    let { type } = param;
    const { __ } = useI18n();
    const { template, isEdit } = type === "service" ? useFormService() : useFormContentBlocker();
    return (template == null ? void 0 : template.consumerData.successorOf.length) > 0 && !isEdit && /*#__PURE__*/ _jsx(Form.Item, {
        name: "succeessorDeletionCheck",
        valuePropName: "checked",
        wrapperCol: {
            offset: FormServiceLayout.labelCol.span
        },
        children: /*#__PURE__*/ _jsx(Checkbox, {
            children: __("Since this template has replaced another one, I would like the old entries using this template to be deleted after submitting this form.")
        })
    });
};
export { FormFieldTemplateSuccessorDeletionCheck };
